import { render, staticRenderFns } from "./UserTab1.vue?vue&type=template&id=708f5de8&scoped=true"
import script from "./UserTab1.vue?vue&type=script&lang=js"
export * from "./UserTab1.vue?vue&type=script&lang=js"
import style0 from "./UserTab1.vue?vue&type=style&index=0&id=708f5de8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708f5de8",
  null
  
)

export default component.exports